<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card tile>
                <v-toolbar
                    card
                    dark
                    class="teal"
                    :class="{'darken-2': !this.$vuetify.dark, 'darken-4': this.$vuetify.dark}"
                >
                    <v-toolbar-title>{{ $t("help") }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false, firstRun = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout fill-height row wrap justify-center>
                        <v-flex xs12 md4 lg3 xl2 d-flex>
                            <v-card
                                :class="{'mr-3': this.$vuetify.breakpoint.mdAndUp}"
                                class="mb-3"
                            >
                                <v-sheet
                                    class="pa-3 teal"
                                    :class="{'darken-2': !this.$vuetify.dark, 'darken-4': this.$vuetify.dark}"
                                >
                                    <v-text-field
                                        v-model="search"
                                        :label="$t('searchTopics')"
                                        dark
                                        flat
                                        solo-inverted
                                        hide-details
                                        clearable
                                        clear-icon="mdi-close-circle-outline"
                                    ></v-text-field>
                                </v-sheet>
                                <v-card-text>
                                    <v-treeview
                                        :active.sync="selected"
                                        :items="items"
                                        :search="search"
                                        :filter="filter"
                                        :open.sync="open"
                                        item-key="path"
                                        activatable
                                        transition
                                        open-on-click
                                    >
                                        <template v-slot:prepend="{ item }">
                                            <v-icon
                                                v-if="item.children"
                                            >{{ `mdi-${item.id === 1 ? 'home-variant-outline' : 'book-open-variant'}` }}</v-icon>
                                        </template>
                                    </v-treeview>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md8 lg8 xl6 p-0 d-flex>
                            <div v-html="content" class="help-container"></div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    export default {
        name: "HelpSystem",

        data () {
            return {
                selected: [],
                dialog: false,
                items: [],
                search: null,
                caseSensitive: false,
                open: [],
                content: "",
                firstRun: false,
                showNews: false,
                redirectToRoot: [
                    "/",
                    "/account",
                    "/companies",
                    "/contacts",
                    "/limits",
                    "/subscription",
                    "/support",
                    "/syslog",
                    "/users",
                ]
            }
        },

        computed: {
            currentRoute () {
                if (this.firstRun) {
                    return "/first_run";
                } else if (this.showNews) {
                    return "/news";
                } else {
                    return this.$route.path;
                }
            },

            filter () {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined
            }
        },

        watch: {
            selected (val) {
                this.loadData(val);
            },

            currentRoute (val) {
                this.content = val;
                this.selected = [ val ];
                this.items.forEach((item) => {
                    if (item.children) {
                        item.children.forEach((child) => {
                            if (child.path == val) {
                                this.open = [ item.id ];
                            }
                        });
                    }
                });

                this.loadData(val);
            },

            dialog (val) {
                this.$store.commit("setHelpDisplayed", val);
            }
        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.items = [
                    { id: 1, name: this.$t("firstRun"), path: "/first_run" },
                    {
                        id: 2,
                        name: this.$t("optimization"),
                        children: [
                            {
                                id: 1001,
                                name: this.$t("cuttingOptimization"),
                                path: "/optimization",
                            },
                            {
                                id: 1002,
                                name: this.$t("optimalDiameter"),
                                path: "/diam_opt"
                            },
                            {
                                id: 1003,
                                name: this.$t("cantProduction"),
                                path: "/cant_opt"
                            }
                        ]
                    },
                    { id: 3, name: this.$t("patternsLibrary"), path: "/patterns" },
                    { id: 4, name: this.$t("threeDLibrary"),   path: "/three_d" },
                    {
                        id: 5,
                        name: this.$t("catalogs"),
                        children: [
                            {
                                id: 5001,
                                name: this.$t("species"),
                                path: "/species"
                            },
                            {
                                id: 5002,
                                name: this.$t("lengths"),
                                path: "/lengths"
                            },
                            {
                                id: 5003,
                                name: this.$t("lumber"),
                                path: "/lumber"
                            },
                            {
                                id: 5004,
                                name: this.$t("prices"),
                                path: "/prices"
                            },
                            {
                                id: 5005,
                                name: this.$t("equipmentProfiles"),
                                path: "/equipment"
                            }
                        ]
                    },
                    {
                        id: 6,
                        name: this.$t("administration"),
                        path: "/acl"
                        /*
                        children: [
                            {
                                id: 6001,
                                name: this.$t("companies"),
                                path: "/companies"
                            },
                            {
                                id: 6002,
                                name: this.$t("users"),
                                path: "/users"
                            },
                            {
                                id: 6003,
                                name: this.$t("accessControl"),
                                path: "/acl"
                            },
                            {
                                id: 6004,
                                name: this.$t("sysLog"),
                                path: "/syslog"
                            }
                        ]
                        */
                    },
                    {
                        id: 7,
                        name: this.$t("settings"),
                        path: "/settings"
                    },
                    {
                        id: 8,
                        name: this.$t("standards"),
                        path: "/standards",
                        children: [
                            {
                                id: 8001,
                                name: this.$t("gosStandards.gost2708_75Short"),
                                path: "/standards/GOST2708-75"
                            },
                            {
                                id: 8002,
                                name: this.$t("gosStandards.gost_r54365_2011Short"),
                                path: "/standards/GOSTP54365-2011"
                            },
                        ]
                    },
                    {
                        id: 9,
                        name: this.$t("lastNews"),
                        path: "/news",
                    },
                    {
                        id: 10,
                        name: this.$t("licenseAgreement"),
                        children: [
                            {
                                id: 10001,
                                name: this.$t("currentEdition"),
                                path: "/eula"
                            },
                            {
                                id: 10002,
                                name: `${this.$t("editionFrom")} 20.10.2022`,
                                path: "/eula/20221020"
                            },
                            {
                                id: 10002,
                                name: `${this.$t("editionFrom")} 01.03.2022`,
                                path: "/eula/20220301"
                            }
                        ]
                    },
                    {
                        id: 11,
                        name: this.$t("privacyPolicy"),
                        path: "/privacy_policy",
                    },
                    {
                        id: 12,
                        name: this.$t("cookiesPolicy"),
                        path: "/cookies_policy",
                    }
                ];
            },

            /**
             * Загрузка данных
             *
             * @param {string} path Путь к загружаемым данным
             */
            loadData (path) {
                path = path[0] == undefined || this.redirectToRoot.includes(path[0])
                    ? ["/first_run"]
                    : path;

                this.axios.get(`../help/${this.$i18n.locale}${path}/index.html`, { withCredentials: true })
                .then(response => {
                    this.content = response.data;
                })
                .catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `Help.vue -> loadData: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    //this.showMessageBox(this.$t("error"), this.$t("cantLoadLoginInfo"));
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>
